import styled from 'styled-components';
import { Table, Nav, NavItem, ButtonGroup } from 'react-bootstrap';

export const TableWrapper = styled(Table)`
    margin-bottom: 0px;
    
    & > thead > tr > th {
        text-align: center;
        border-right: 1px solid white;
        border-bottom: 1px solid white;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    @media (max-width: 1823px) {
        & > thead > tr > th,
        & > tbody > tr > td {
            font-size: 12px;
        }

        & > tbody > tr > td > .badge {
            font-size: 12px
        }

        & > tbody > tr > td > .btn {
            font-size: 12px;
        }
    }
`;

export const HeaderRowWrapper = styled.tr`
    & > th {
        text-align: center;
        font-size: 14px;
    }
`;

export const RowWrapper = styled.tr`
    & > td {
        text-align: center;
        font-size: 12px;
    }
`;

export const ListWrapper = styled.div`
    .react-grid-Main {
        border-bottom: 1px solid #ddd;

        outline: 1px solid white;

        .react-grid-Grid {
            border: 1px solid white;

            .react-grid-HeaderCell {
                border-right: 1px solid white;
                padding-top: 4px;
                padding-bottom: 4px;
            }

            .react-grid-HeaderCell-sortable {
                bottom: 4px;
                position: absolute;
                width: 90%
            }

            .widget-HeaderCell__value {
                bottom: 4px;
                position: absolute;
                width: 90%
            }

            .react-grid-Cell:focus {
                outline: none;
            }
        }
    }
`;

// export const NavWrapper = styled(Nav)`
//     border-bottom: 1px solid transparent;

//     & > li.active > a {
//         background-color: #d9edf7 !important;
//     }

//     & > li.active > a,
//     & > li.active > a:hover,
//     & > li.active > a:focus {
//         // color: white !important;
//     }
// `;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    fontSize?: string,
    width?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    display: flex;
    // justify-content: space-between;
    align-items: center;
    width: ${(p: INavWrapperProps) => p.width ? p.width : '100%'};
    // margin-bottom: 20px;
    // border: 1px solid red;

    & > .acc-tabs > li {
        height: 48px;
    }

    & > .acc-tabs > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > .acc-tabs > li.active > a {
        color: #555;
        background-color: #fff;
    }

    & > div > .acc-pills > li > a {
        padding: 5px 7px;
        // font-size: ${(p: INavWrapperProps) => p.fontSize != null ? p.fontSize : '14px'};
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
    }

    & > div > .acc-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 2px;
        color: #ccc;
        // min-height: 72px;
    }

    & > div > .acc-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid #ccc
    }

    & > div > .acc-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid #ccc
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            min-width: 120px;
        }
    }
`;

export const NavItemWrapper = styled(NavItem)`
    & > a {
        // padding: 5px 7.5px !important;
        font-size: 14px;
    }
`;

interface IRecipientRowWrapperProps {
    hasCustomLogistics: boolean
}

export const RecipientRowWrapper = styled.tr<IRecipientRowWrapperProps>`
    border: ${p => p.hasCustomLogistics ? '2px solid #CF3030' : '0 none'};
`;

export const LogisticsGpsWrapper = styled(ButtonGroup)`
    & > button {
        min-width: 25px;
    }

    @media (max-width: 1823px) {
        & > button {
            font-size: 10px;
        }
    }
`;

export const PanelsWrapper = styled.div`
    @media (max-width: 1824px) {
        font-size: 12px;
    }

    .panel-heading {
        background-color: white;
    }

    .panel-body {
        padding: 0px;
    }
`;